module.exports = __webpack_public_path__ + "5ce99a3b5fc87ecbb504cfbeedbc87e0.pdf";